import { render, staticRenderFns } from "./SupplierTransactionDetail.vue?vue&type=template&id=d092da46"
import script from "./SupplierTransactionDetail.vue?vue&type=script&lang=js"
export * from "./SupplierTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports